// extracted by mini-css-extract-plugin
module.exports = {"root":"_190690c","header":"_c0b2e84","textContainer":"_22ad9fd"};